/* eslint-disable no-param-reassign,no-prototype-builtins,no-loop-func */

import _ from 'lodash';

export const step6ExpenseLookup = {
  claimForTripCancellationExpenses: {
    claimCode: '',
    associatedClaimCodes: ['AC', 'NC', 'KC', 'RB', 'RC', 'SG', 'FD', 'GE', 'GG', 'HD', 'HF', 'WA', 'WB', 'WK', 'WL', 'WM', 'WS', 'WT'],
  },
  claimForTripDisruptionOrAdditionalExpenses: {
    claimCode: 'TD',
  },
  claimForTripResumptionExpenses: {
    claimCode: 'TR',
  },
  claimForAlternativeTransportExpenses: {
    claimCode: 'AT',
  },
  claimForATravelDelay: {
    claimCode: '',
    associatedClaimCodes: ['AG', 'NG', 'KZ', 'RZ', 'SL', 'FG', 'GH', 'HG', 'WV'],
  },
  claimForAdditionalExpenses: {
    claimCode: '',
    associatedClaimCodes: ['RA', 'KA', 'SH', 'FE', 'GF', 'HE'],
  },
  claimCodeList: ['AC', 'AG', 'NC', 'NG', 'KC', 'KZ', 'KA', 'RB', 'RZ', 'RA', 'RC', 'SH', 'SG', 'SL', 'FD', 'FG', 'FE', 'GE', 'GG', 'GH', 'GF', 'HD', 'HF', 'HG', 'HE',
    'WA', 'WB', 'WK', 'WL', 'WM', 'WS', 'WT', 'WV'],
};

export const step7ExpenseLookup = {
  claimForDelayLuggage: {
    claimCode: '',
    associatedClaimCodes: ['AL', 'NL', 'KE', 'RG', 'RE', 'SO', 'FI', 'GJ', 'HI', 'WI'],
  },
  claimForPassportCreditCard: {
    claimCode: 'PC',
  },
  claimForTheftOfCash: {
    claimCode: 'TH',
  },
  claimForLuggageAndPersonalEffect: {
    claimCode: '',
    associatedClaimCodes: ['AI', 'NI', 'KL', 'RL', 'SN', 'FH', 'GI', 'GK', 'GL', 'HH', 'HJ', 'HK', 'WG', 'WH', 'WJ', 'WY'],
  },
  claimCodeList: ['AI', 'AL', 'NI', 'NL', 'KL', 'KE', 'RL', 'RE', 'SN', 'SO', 'FI', 'FH', 'GJ', 'GI', 'GK', 'GL', 'HI', 'HH', 'HJ', 'HK',
    'WG', 'WH', 'WI', 'WJ', 'WY'],
};

export const step8ExpenseLookup = {
  areYouClaimingForEmergencyMedicalAndHospitalExpenses: {
    claimCode: '',
    associatedClaimCodes: ['AE', 'NE', 'KO', 'RO', 'SA', 'SC', 'FA', 'GA', 'GB', 'GC', 'GD', 'HA', 'HB', 'HC', 'WC', 'WD', 'WE', 'WX'],
  },
  areYouClaimingForLossOfIncome: {
    claimCode: '',
    associatedClaimCodes: ['KI', 'RI', 'SV', 'FO', 'GQ', 'HP', 'WR'],
  },

  claimCodeList: ['AE', 'NE', 'KI', 'KO', 'RI', 'RO', 'SV', 'SA', 'SC', 'FA', 'FO', 'GA', 'GB', 'GC', 'GD', 'GQ', 'HA', 'HB', 'HC', 'HP', 
    'WC', 'WD', 'WE', 'WR', 'WX'],
};

export const step9ExpenseLookup = {
  areYouClaimingForRentalVehicleExcess: {
    claimCode: '',
    associatedClaimCodes: ['AR', 'NR', 'KV', 'RV', 'SM', 'FQ', 'GM', 'HL', 'WQ'],
  },
  claimCodeList: ['AR', 'NR', 'KV', 'RV', 'SM', 'FQ', 'GM', 'HL', 'WQ'],
};

export const step10ExpenseLookup = {
  areYouClaimingForSnowSportEquipment: {
    claimCode: '',
  },
  areYouClaimingForSnowEquipmentReplacementHire: {
    claimCode: '',
  },
  areYouClaimingForSnowPrepaidExpenses: {
    claimCode: '',
  },
  areYouClaimingForSnowResortClosure: {
    claimCode: '',
  },
  claimCodeList: [],
};

export const step11ExpenseLookup = {
  areYouClaimingForPersonalLiability: {
    claimCode: '',
    associatedClaimCodes: ['AP', 'NP', 'KY', 'RY', 'SQ', 'FL', 'GN', 'HM', 'WP'],
  },
  isThereAnyThingElseYouWouldLikeToClaimFor: {
    claimCode: '',
    associatedClaimCodes: ['AP', 'NP', 'KY', 'RY', 'SQ', 'FL', 'GN', 'GO', 'GP', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ', 'HM', 'HN', 'HO', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV',
    'WF', 'WN', 'WO', 'WU', 'WW', 'WZ', 'W0', 'W1', 'W2'],
  },
  claimCodeList: ['AP', 'NP', 'KY', 'RY', 'SQ', 'FL', 'GN', 'GO', 'GP', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ', 'HM', 'HN', 'HO', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV',
    'WF', 'WN', 'WO', 'WP', 'WU', 'WW', 'WZ', 'W0', 'W1', 'W2'],
};

export const emptyClaimCode = '';

const listCodeNeedToCovert = [
  {
    from: ['RS', 'RQ', 'RD'],
    to: 'RY',
  },
  {
    from: ['RM', 'RH', 'RD', 'RP'],
    to: 'RO',
  },
  {
    from: ['RX'],
    to: 'RL',
  },
  {
    from: ['KS', 'KD'],
    to: 'KY',
  },
  {
    from: ['KM', 'KH', 'KP'],
    to: 'KO',

  },
  {
    from: ['KX'],
    to: 'KL',
  },
  {
    from: ['SR', 'SS', 'ST', 'SW', 'SX', 'SY', 'SZ', 'S0', 'S1', 'S2', 'S3', 'S4', 'SU'],
    to: 'SQ',
  },
  {
    from: ['SB', 'SC', 'SD', 'SE', 'SF'],
    to: 'SA',
  },
  {
    from: ['SP'],
    to: 'SN',
  },
  {
    from: ['SI'],
    to: 'SH',
  },
  {
    from: ['SJ', 'SK'],
    to: 'SG',
  },


  {
    from: ['FJ', 'FK'],
    to: 'FH',
  },
  {
    from: ['FM', 'FN', 'FP', 'FR', 'FS', 'FT', 'FU'],
    to: 'FL',
  },
  {
    from: ['FB', 'FC'],
    to: 'FA',
  },
  {
    from: ['FF'],
    to: 'FE',
  },
  {
    from: ['GA', 'GB', 'GC', 'GD'],
    to: 'GC',
  },
  {
    from: ['GE', 'GG'],
    to: 'GE',
  },
  {
    from: ['GI', 'GK', 'GL'],
    to: 'GI',
  },
  {
    from: ['GN', 'GO', 'GP', 'GR', 'GS', 'GT', 'GU', 'GV', 'GW', 'GX', 'GY', 'GZ'],
    to: 'GN',
  },
  {
    from: ['HA', 'HB', 'HC'],
    to: 'HB',
  },
  {
    from: ['HD', 'HF'],
    to: 'HD',
  },
  {
    from: ['HH', 'HJ', 'HK'],
    to: 'HH',
  },
  {
    from: ['HM', 'HN', 'HO', 'HQ', 'HR', 'HS', 'HT', 'HU', 'HV'],
    to: 'HM',
  },
  {
    from: ['WA', 'WB', 'WK', 'WL', 'WM', 'WS', 'WT'],
    to: 'WA',
  },
  {
    from: ['WC', 'WD', 'WE', 'WX'],
    to: 'WC',
  },
  {
    from: ['WQ'],
    to: 'WQ',
  },
  {
    from: ['WG', 'WH', 'WJ', 'WY'],
    to: 'WG',
  },
  {
    from: ['WF', 'WN', 'WO', 'WU', 'WW', 'WZ', 'W0', 'W1', 'W2'],
    to: 'WO',
  },
  {
    from: ['WV'],
    to: 'WV',
  },
  {
    from: ['WI'],
    to: 'WI',
  },
  {
    from: ['WR'],
    to: 'WR',
  },
  {
    from: ['WP'],
    to: 'WP',
  },
];

export const convertClaimCode = (claimTypes, policyTypeId) => {
  claimTypes.forEach((data) => {
    const rs = _.find(listCodeNeedToCovert, (x) => x.from.indexOf(data.claimCode) > -1);
    if (rs) {
      if (policyTypeId !== 58 || data.claimCode !== 'SC') {
        data.claimCode = rs.to;
      }
    }
  });
  return claimTypes;
};


export function configClaimCodeMapper(claimTypes, policyTypeId) {
  // The claimCodes cotnains the following format
  /*
    [{claimTypeId: '',
      description: '',
      claimCode: ''}]
  */
  const converted = convertClaimCode(claimTypes, policyTypeId);
  const expenses = [step6ExpenseLookup, step7ExpenseLookup, step8ExpenseLookup, step9ExpenseLookup, step11ExpenseLookup];
  expenses.forEach((expense) => {
    /*
    We need to dynamically update the Claim Code for the Expense that has multiple claim codes assigned,
    i.e. the Expense that has "associatedClaimCodes" property defined
    */
    // const containMutlipleClaimCodes = false;
    let expenseIndex = -1;
    const properties = Object.keys(expense);
    for (let i = 0; i < properties.length; i++) {
      if (expense[properties[i]].hasOwnProperty('associatedClaimCodes')) {
        // containMutlipleClaimCodes = true;
        expenseIndex = i;
        expense[properties[expenseIndex]].associatedClaimCodes.forEach((claimCode) => {
          const claimTypeFound = !!(_.find(converted, (o) => o.claimCode === claimCode));
          if (claimTypeFound) {
            expense[properties[expenseIndex]].claimCode = claimCode;
          }
        });
      }
    }

    // if (containMutlipleClaimCodes) {
    //   expense[properties[expenseIndex]].associatedClaimCodes.forEach((claimCode) => {
    //     const claimTypeFound = !!(_.find(claimTypes, (o) => o.claimCode === claimCode));
    //     if (claimTypeFound) {
    //       expense[properties[expenseIndex]].claimCode = claimCode;
    //     }
    //   });
    // }
  });
}




// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/claimCodeMapper.js